import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Multiplicar tus plantas favoritas sin gastar en viveros', 'Saber exactamente qué hacer en cada etapa (sin improvisar)', 'Evitar los errores que matan el 80% de los esquejes', 'Tener plantas nuevas en 4-8 semanas (según la especie)', 'Aplicar el método a cualquier planta de tu casa o jardín', 'Dejar de perder tiempo buscando videos sueltos en internet'];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="max-w-5xl mx-auto" data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-5">
              Qué vas a lograr con esta guía
            </h2>
            <p className="text-xl text-gray-600" data-id="element-6">
              Resultados concretos que vas a ver en las próximas semanas
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-6 rounded-xl bg-[#fafaf9] border border-gray-100 hover:border-[#4a7c2c]/30 transition-colors" data-id="element-8">
                <div className="w-8 h-8 rounded-full bg-[#4a7c2c]/10 flex items-center justify-center flex-shrink-0 text-[#4a7c2c]" data-id="element-9">
                  <Check className="w-5 h-5" data-id="element-10" />
                </div>
                <p className="text-gray-800 font-medium" data-id="element-11">{benefit}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}